module.exports = __webpack_public_path__ + "smoke.4059764.png";